import styled from "styled-components";

const ProfileInfoContainer = styled.div`
    padding-top: 2rem;
    @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
        padding-top: 3.5rem;
    }
    .verified {
        margin: 0.5rem 0;
        position: relative;
        padding-left: 1.5rem;
        margin-left: 1rem;
        font-size: 1.2rem;
        color: ${props => props.theme.lightGray4};
        display: block;
        @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
            display: inline;
            padding-left: 2.5rem;
        }
        &:before {
            content: "";
            width: 1.5rem;
            height: auto;
            background-position: bottom 0.3rem right;
            position: absolute;
            left: -0.4rem;
            top: -0.5rem;
            bottom: 0.5rem;
            background-image: url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMTJweCIgaGVpZ2h0PSI5cHgiIHZpZXdCb3g9IjAgMCAxMiA5IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPgogICAgPCEtLSBHZW5lcmF0b3I6IFNrZXRjaCA1OS4xICg4NjE0NCkgLSBodHRwczovL3NrZXRjaC5jb20gLS0+CiAgICA8dGl0bGU+R2xvYmFsL0F0b21zL0ljb25zL1RpY2sgZ3JlZW48L3RpdGxlPgogICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+CiAgICA8ZyBpZD0iU3ltYm9scyIgc3Ryb2tlPSJub25lIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIj4KICAgICAgICA8ZyBpZD0iU2Vjb25kYXJ5LXRleHQvbGVmdCIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMC4wMDAwMDAsIC03LjAwMDAwMCkiIHN0cm9rZT0iIzAwQTc2QSIgc3Ryb2tlLXdpZHRoPSIyIj4KICAgICAgICAgICAgPGcgaWQ9Ikdsb2JhbC9BdG9tcy9JY29ucy9UaWNrLWdyZWVuIiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgwLjAwMDAwMCwgOC4wMDAwMDApIj4KICAgICAgICAgICAgICAgIDxsaW5lIHgxPSIxLjExMTYyNzgzIiB5MT0iMy4wNzk1MTI4MyIgeDI9IjQuMDk3NzQxOTQiIHkyPSI2LjIxNDkzMjY0IiBpZD0iU3Ryb2tlLTIzIj48L2xpbmU+CiAgICAgICAgICAgICAgICA8bGluZSB4MT0iMTAuMjI4NjcxNyIgeTE9IjAiIHgyPSI0LjIxMDUwNzE5IiB5Mj0iNi4yODI2NTAzNyIgaWQ9IlN0cm9rZS0yNSI+PC9saW5lPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=");
            background-size: 1.4rem;
            background-repeat: no-repeat;
            @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
                left: 0.4rem;
                bottom: 0;
            }
        }
    }
    .security__footer {
        font-size: 1.2rem;
        color: ${props => props.theme.lightGray4};
        font-weight: bold;
        margin-top: 5rem;
        a {
            font-size: 1.2rem;
            color: ${props => props.theme.lightGray4};
            text-decoration: none;
            font-weight: bold;
        }
    }
`;

const BusinessBtnWrapper = styled.div`
    padding-top: 1rem;
    .blueBtn {
        background-color: ${props => props.theme.teal};
        color: ${props => props.theme.white};
        border: ${props => props.theme.darkBlueBorder};
        &:hover {
            background-color: ${props => props.theme.lightTeal};
            color: ${props => props.theme.white};
            border: ${props => props.theme.lightTielBorder};
        }
    }
`;

const BusinessDescWrapper = styled.div``;

export { ProfileInfoContainer, BusinessBtnWrapper, BusinessDescWrapper };
